import { get, map, size, startCase, trim, values } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { Divider } from '@mui/material';

import styles from './Deliveries.module.css';

function DeliveryDetails(props) {
  const { delivery, locations } = props;
  const userId = get(delivery, 'vendor.contacts[0].id');
  const orders = get(
    delivery,
    'purchaseOrders',
    get(delivery, 'purchase_orders'),
  );

  return (
    <div className={styles.deliveryDetails}>
      <div className={styles.deliveryDetail}>
        <span>Boxes:</span>
        <span>{delivery.boxes}</span>
      </div>

      <Divider />

      <div className={styles.deliveryDetail}>
        <span>Units:</span>
        <span>{delivery.units}</span>
      </div>

      <Divider />

      <div className={styles.deliveryDetail}>
        <span>Delivery Date and Time:</span>
        <span>
          {moment.utc(delivery.timeSlot || delivery.starts_at).format('LLLL')}
        </span>
      </div>

      <div className={styles.deliveryDetail}>
        <span>Delivery Location:</span>
        <span>{startCase(get(locations, `${delivery.location_id}.name`))}</span>
      </div>

      <Divider />

      <div className={styles.deliveryDetail}>
        <span>Purchase Orders for Delivery:</span>
        <div>
          {map(values(orders), (po, i, coll) => (
            <Link
              key={po.po_number}
              target="_blank"
              to={`/users/${userId}/purchase-orders/${po.po_number}`}
              className={styles.poLink}
            >
              {`${trim(po.po_number)}
              ${po.vendor_rejection_reason ? '(rejected)' : ''}${
                i < size(coll) - 1 ? ', ' : ''
              }`}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

DeliveryDetails.propTypes = {
  delivery: PropTypes.shape({}).isRequired,
  locations: PropTypes.shape({}).isRequired,
};

export default DeliveryDetails;
